var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.795201 11.7132C-0.265067 12.5062 -0.265067 13.7942 0.795201 14.5872L14.3666 24.7383C15.4269 25.5314 17.1488 25.5314 18.209 24.7383C19.2693 23.9453 19.2693 22.6573 18.209 21.8643L6.55458 13.147L18.2006 4.42976C19.2608 3.63671 19.2608 2.34878 18.2006 1.55573C17.1403 0.762674 15.4184 0.762674 14.3581 1.55573L0.786719 11.7068L0.795201 11.7132Z","fill":"#36373A"}));
}

LeftArrow.defaultProps = {"width":"19","height":"26","viewBox":"0 0 19 26","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
